import { ID } from '@/data/types/Basic';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';

export const CenefaBrandsMobile: React.FC<{
	id: ID;
}> = ({ id }) => (
	<ContentRecommendation
		id={`${id}-FooterCenefaShippingMobileDrawer`}
		properties={{
			emsName: 'FooterCenefaShippingMobileDrawer',
		}}
	/>
);
